import request from '../requestPB'
import { ALI_DOMAIN } from '../constant'

// 报告列表 POST api/v1/appraisal/report
export const fetchAliAppraisalReportList = ({ seriesNum }) => {
    return request({
        url: `${ALI_DOMAIN}/api/v1/appraisal/report`,
        method: 'POST',
        data: { seriesNum }
    }, {
        PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.AppraisalReportListRequest',
        PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.AppraisalReportListResponse',
        TOKEN_REQUIRED: false,
        ERROR_ACTION: 'toast',
        httpAddress: 'ali',
    })
}

